import { v4 as uuidv4 } from 'uuid';
import { Product, getOnpremHostname, isNullOrWhitespaces } from 'omni-package-react-core';
import { ProductDto } from '../../interfaces/Dto/ProductDto';
import { ProductGroupDto } from '../../interfaces/Dto/ProductGroupDto';

export default function transformProducts(groupDtos: ProductGroupDto[]): Product[] {
  const products: Product[] = [];

  if (!groupDtos || groupDtos.length === 0) return products;

  groupDtos.sort(compare).forEach((groupDto) => {
    if (groupDto.isUniqueLinkVisible) {
      const group = {
        ...mapBaseProperties(groupDto),
        uniqueLinkText: groupDto.uniqueLinkText,
      };
      products.push(group);
    }

    groupDto.products?.sort(compare).forEach((dto) => {
      const product = {
        ...mapBaseProperties(dto),
        normalizedContractNumber: dto.normalizedContractNumber,
        systemCode: dto.systemCode,
        productCode: dto.productCode,
      };
      products.push(product);
    });
  });

  return products;
}

function mapBaseProperties(dto: ProductGroupDto | ProductDto) {
  let path = `${getOnpremHostname()}/${dto.browsingValue?.replace('/', '')}`;
  if (dto.isClickable && isNullOrWhitespaces(dto.browsingValue)) {
    path = 'https://ia.ca';
  }

  return {
    id: uuidv4(),
    description: dto.description,
    isClickable: dto.isClickable,
    browsingValue: path,
    order: dto.order,
    ownerCode: dto.ownerCode,
    iconCode: dto.iconCode,
  } as Product;
}

function compare(a: ProductGroupDto | ProductDto, b: ProductGroupDto | ProductDto) {
  if (a.order < b.order) {
    return -1;
  }
  if (a.order > b.order) {
    return 1;
  }
  return 0;
}
